import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MinimalistHero from "@/components/MinimalistHero";
import StatsStrip from "@/components/StatsStrip";
import MinimalistFeatures from "@/components/MinimalistFeatures";
import USPShowcase from "@/components/USPShowcase";
import TeacherEarnings from "@/components/TeacherEarnings";
import MinimalistCTA from "@/components/MinimalistCTA";
import ReviewsWall from "@/components/ReviewsWall";
import { useAuth } from '@/contexts/AuthContext';
import { useRole } from '@/hooks/useRole';

const Index: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { roles, isLoading } = useRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading && (roles?.length || 0) === 0) {
      navigate('/role-selection');
    }
  }, [isAuthenticated, roles, isLoading, navigate]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main>
        <h1 className="sr-only">EduLabs - Create and Manage Classrooms, Exams and Students</h1>
        <MinimalistHero />
        <StatsStrip />
        <MinimalistFeatures />
        <USPShowcase />
        <TeacherEarnings />
        <ReviewsWall />
        <MinimalistCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
